/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect, useRef } from "react";

import { gql, useLazyQuery } from "@apollo/client";

import { LIST_COMPANY_FRAGMENT, ListCompanyFragment } from "graphql/fragments";
import { QueryCompaniesArgs } from "graphql/types";

import { PaginatedPayload } from "./shared/types";

const COMPANIES = gql`
  query ($name: String!, $page: Int, $perPage: Int) {
    companies(name: $name, page: $page, perPage: $perPage) {
      exportPath
      items {
        ...ListCompanyFragment
      }
      total
    }
  }
  ${LIST_COMPANY_FRAGMENT}
`;

export interface CompaniesQuery {
  companies: PaginatedPayload<ListCompanyFragment>;
}

type QueryArgs = Pick<QueryCompaniesArgs, "name" | "page" | "perPage">;

export const useCompaniesLazyQuery = () => {
  const [getCompaniesQuery, { data, loading: isLoading, called }] =
    useLazyQuery<CompaniesQuery, QueryArgs>(COMPANIES);

  const companies = data?.companies.items?.filter(Boolean) ?? [];

  const resolveRef =
    useRef<(companies?: ListCompanyFragment[]) => void>(undefined);

  useEffect(() => {
    if (called && !isLoading && resolveRef.current) {
      resolveRef.current(companies);
      resolveRef.current = undefined;
    }
  }, [companies, called, isLoading]);

  const getCompanies = async (variables: QueryArgs) => {
    getCompaniesQuery({ variables });

    return new Promise<ListCompanyFragment[] | undefined>((resolve) => {
      resolveRef.current = resolve;
    });
  };

  return { getCompanies, companies, isLoading };
};
